import { Component } from "@angular/core";

export class assignUserModelItem {
    public planId: any = -1;
    public mode: string = "";
    public currPGMIndicator: string = "";
    public currAssignedUserId: string = "";
    public planType: string = "";
    public agencyType: string = "";
}
